import React from "react";

const POSPrintKOT = ({
  cart,
  reciptDetails,
  totalPrice,
  mobile,
  orderType,
  orderId,
  tenderedAmount,
  selectedDiscount,
  apiResponsePrint = [],
}) => {
  const handleKitchenPrint = (reciptDetails, item, fullAddress) => {
    const formattedAddress = fullAddress.replace(/,/g, ",&nbsp;");
    const printWindow = window.open("", "_blank");

    const orderKey = `printedOrders_${item.orderid}`;
    let printedItemsForOrder = JSON.parse(localStorage.getItem(orderKey)) || [];

    const unprintedItems = item.items.filter(
      (subitem) => !printedItemsForOrder.includes(subitem.id)
    );

    if (unprintedItems.length === 0) return;

    const kitchenReceiptHTML = `
      <html>
        <head>
        <style>
                    @page {
                        size: 80mm;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                        margin-right:15px;
                        font-family: Arial, sans-serif;
                        font-size: 16px;
                        color: black;
                    }
                    .header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center; 
                        align-items: center;         
                        text-align: center;            
                        color: #000;
                        line-height: 1.1;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                    }
                    .header2 {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                       line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                        padding-bottom: 0px;
                    }
                    .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.2;
                        border-bottom: 1px dashed #000;
                        padding: 0;
                        margin: 0;
                    }
                    .headerTotal {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;
                        text-align: left;            
                        color: #000;
                        line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        padding-bottom: 5px;
                        padding-top: 5px;
                        padding:0px;
                    }
                        .flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
                    .headerEnd {
                    padding-top: 5px;
                        text-align: center;            
                        color: #000; 
                        padding-bottom: 0px;
                    }
                    .textSizeLarge {
                        font-size: 16px;
                        margin: 1px;
                        padding: 1px;
                    }
                    .textSizeMid {
                        font-size: 12px;
                        margin: 0px;
                        padding: 0px;
                    }
                    .textSizeSmall {
                        font-size: 9px;
                        margin: 1px;
                        padding: 1px;
                    }
                    .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th,
                    .order-details td { padding: 0px;  padding-top: 5px;  padding-bottom: 5px; font-size: 12px; text-align: left;  vertical-align: top; }
                    .table-text-center { text-align: center; }
                </style>
        </head>
        <body>
          <div class="container">
              <div class="header" style="text-align: left;">
  <p class="textSizeLarge" style="font-weight: 600; margin: 5px 0;">${
    reciptDetails.business_name
  }</p>
   <p class="textSizeLarge" style="font-weight: 600; margin: 5px 0;">** KOT **</p>
  <p class="textSizeMid" style="margin: 5px 0;">
    <strong>Order ID:</strong> <strong>${item.daily_order_id} / ${item.orderid}</strong>
  </p>
  
  <p class="textSizeMid" style="margin: 5px 0;">Order Type: ${
    item.orderType
  }</p>
    ${
                         item.orderType === "dining"
                           ? `
  <p class="textSizeMid">Table No: ${item.table_no}</p>
`
                           : ""
                       }
</div>

            <div class="headerTable">
              <table class="order-details">
                <thead>
                  <tr>
                    <th class="table-text-center">Sr.</th>
                    <th class="table-text-center">ITEM</th>
                    <th class="table-text-center">QTY</th>
                    <th class="table-text-center">PRICE</th>
                  </tr>
                </thead>
                <tbody>
                  ${item.items
                    .map((subitem, index) => {
                   let customizationText = "";

try {
  const customization =
    subitem.customization && subitem.customization !== "{}"
      ? JSON.parse(subitem.customization)
      : null;

  if (Array.isArray(customization)) {
    const parts = customization.map((item) => {
      const options = Array.isArray(item.options) ? item.options.join(", ") : "";
      return `${options}`;
    });

    customizationText = parts.length
      ? `\n(${parts.join(" | ")})` // ✅ Plain text format for thermal printer
      : "";
  } else {
    customizationText = "";
  }
} catch {
  customizationText = `\n(Invalid customization)`; // fallback
}

                      return `
                        <tr>
                          <td class="table-text-center">${index + 1}</td>
                          <td>${subitem.item_name}${customizationText}</td>
                          <td class="table-text-center">${subitem.quantity}</td>
                          <td class="table-text-center">${parseFloat(
                            subitem.item_price
                          ).toFixed(2)}</td>
                        </tr>
                      `;
                    })
                    .join("")}
                </tbody>
              </table>
            </div>
<div class="headerEnd">
                        <p class="textSizeMid">Print Date : ${
                          item.update
                        }</p>
                    </div>
        
          </div>
        </body>
      </html>
    `;

    printWindow.document.write(kitchenReceiptHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    const updatedPrintedItems = [
      ...printedItemsForOrder,
      ...unprintedItems.map((subitem) => subitem.id),
    ];
    localStorage.setItem(orderKey, JSON.stringify(updatedPrintedItems));
  };

  return (
    <>
      <button
    onClick={() => {
  if (Array.isArray(apiResponsePrint)) {
    apiResponsePrint.forEach((order) => handleKitchenPrint(reciptDetails, order, ""));
  } else if (typeof apiResponsePrint === "object" && apiResponsePrint !== null) {
    handleKitchenPrint(reciptDetails, apiResponsePrint, "");
  } else {
    console.error("apiResponsePrint is empty or invalid.");
  }
}}
        style={{ height: "120px", width: "250px" }}
        className="shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
      >
        PRINT KOT
      </button>
    </>
  );
};

export default POSPrintKOT;
